import { render, staticRenderFns } from "./MegaMenu.vue?vue&type=template&id=42a785e0&scoped=true&"
import script from "./MegaMenu.vue?vue&type=script&lang=ts&"
export * from "./MegaMenu.vue?vue&type=script&lang=ts&"
import style0 from "./MegaMenu.vue?vue&type=style&index=0&id=42a785e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a785e0",
  null
  
)

export default component.exports